import get from 'lodash/get'
import { required, withinCodetable } from '../../utils/validations'

const validate = (values: any, props: any) => ({
  employmentTypeCode: required(get(values, 'employmentTypeCode')),
  professionCode:
    required(get(values, 'professionCode')) ||
    withinCodetable(
      get(values, 'professionCode'),
      props.occupationsByEmploymentType[get(values, 'employmentTypeCode')]
    ),
})

export default validate
